import { render, staticRenderFns } from "./BindAccountList.vue?vue&type=template&id=dcaf2eee&"
import script from "./BindAccountList.vue?vue&type=script&lang=js&"
export * from "./BindAccountList.vue?vue&type=script&lang=js&"
import style0 from "./BindAccountList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports